export default "__VITE_ASSET__D3$qI1_8__"